import { useArtifactDownloadUrl } from './useArtifactDownloadUrl'

/**
 * Fetches the presigned download URL for an artifact's image file.
 * Returns `{ url, loading, error }`; see `useArtifactDownloadUrl`.
 */
export const useArtifactImageUrl = useArtifactDownloadUrl
